<div [formGroup]="petitionTaskForm">
  <div class="p-fluid p-formgrid p-grid" *ngIf="isExtension">
    <div class="p-col-12">
      <label class="label-large-bold">Choose from the options below</label>
      <div>
        <label class="create-task-label">Do you want to duplicate data from previous petition? </label>
        <p-inputSwitch (onChange)="isDuplicatedtoggle('duplicated', $event.checked)" name="isDuplicatedData" formControlName="" class="pl-2 pull-right">
        </p-inputSwitch>
      </div>
    </div>
  </div>
  <div class="p-grid dashed-line p-my-4" *ngIf="isExtension"></div>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-col-12">
      <label class="label-large-bold">Sub - Task type </label>
      <div><b>Petition</b></div>
    </div>
  </div>
  <div class="p-mt-3">
    <div *ngIf="!isOutsideImagility">
      <div class="p-grid" *ngIf="visaType === 'O1A' || visaType === 'O1B'">
        <!-- <div class="p-col-12">
          <label class="label-large-bold">Other Information</label>
        </div> -->
        <div class="p-col-9"><label class="create-task-label question required">Field of extraordinary ability </label>
        </div>
        <div class="p-col-12 mb-2" name="create-task-label question">
          <div class="p-grid">
            <div class="p-col-4">
              <p-dropdown class="extra-ordinary-dropdown" [options]="fieldExtrAbltyCodeList"
                formControlName="fieldExtrAbltyCode" name="fieldExtrAbltyCode" optionLabel="name" optionValue="code"
                placeholder="Select field of extraordinary ability">
              </p-dropdown>
              <span class="invalid-message"
                *ngIf="petitionTaskForm.get('fieldExtrAbltyCode').touched && petitionTaskForm.get('fieldExtrAbltyCode').errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>
          </div>
        </div>
        <div class="p-col-9">
          <label for="tasktype" class="create-task-label question required">Applicable categories of Documentary
            Evidence</label>
        </div>
        <div class="p-col-12">
          <div class="p-grid">
            <div class="p-col-10">
              <p-radioButton name="extrAblDocEvdCatgCode" (click)="clickRadioBtn(extraBLDOCEVDNCATGList[0].code)"
                formControlName="extrAblDocEvdCatgCode" [value]="extraBLDOCEVDNCATGList[0].code"
                inputId="extrAblDocEvdCatgCode0" label={{extraBLDOCEVDNCATGList[0].desc}}></p-radioButton>
            </div>
          </div>
          <div class="p-grid mt-2 mb-2 ml-1">Or</div>
          <div class="p-grid">
            <div class="p-col-12">
              <p-radioButton name="extrAblDocEvdCatgCode" (click)="clickRadioBtn(extraBLDOCEVDNCATGList[1].code)"
                formControlName="extrAblDocEvdCatgCode" [value]="extraBLDOCEVDNCATGList[1].code"
                inputId="extrAblDocEvdCatgCode1" label={{extraBLDOCEVDNCATGList[1].desc}}></p-radioButton>
            </div>
          </div>
          <div class="p-grid mt-2 mb-2">
            <div class="p-col-12" *ngFor="let item of majorInternationAwardList; let i = index;"
              formArrayName="applicableOptionIds">
              <p-checkbox
                [disabled]="petitionTaskForm.get('extrAblDocEvdCatgCode').value === extraBLDOCEVDNCATGList[0].code"
                [formControlName]="i" binary="true" name="applicableOption" [label]="item.description"
                (onChange)="updateCheckedOptions($event.checked, item.code)">
              </p-checkbox>
            </div>
          </div>
        </div>
        <div class="p-col-9 py-0">
        <label class="d-flex">
          <span> Does any beneficiary in this petition have ownership interest in the petitioning organization?</span><i class="pi pi-info-circle pl-2 pt-1" pTooltip="Select explicitly the required option" tooltipPosition="top"
          style=" color: lightblue;height: 1.457rem;">
          </i>
        </label>
        </div>
        <div class="p-col-1 py-0">
          <p-inputSwitch color="primary" (onChange)="onExtraQuestionToggle()" formControlName="ownershipInterestInPetitionOrg"></p-inputSwitch>
        </div>
        <div class="p-col-10 pt-0">
            <label class="">Explanation <small>(if selected yes above)</small></label>
            <textarea rows="3" formControlName="explanationownershipInterestInPetitionOrg" class="create-task-textarea d-block p-inputtext"
              placeholder="Enter"></textarea>
        </div>
      </div>
      <div formArrayName="questionAndResponseDTO" *ngFor="let a of getFormQuestionsArray(); let i = index">
        <div [formGroupName]="i" *ngIf="(!questionList[i].conditionalVisibilityAtTask || (questionList[i].conditionalVisibilityAtTask && (subTaskDetails?.taskTypeDetails?.petitionType === 'NEW' || subTaskDetails?.taskTypeDetails?.petitionType === 'CAP' )))">
          <div class="p-grid">
            <div class="p-col-9" name="create-task-label question">
              {{questionList[i]?.question}} 
            </div>
            <div class="p-col-1" *ngIf="questionList[i].isBoolean == 1 || questionList[i].isBoolean">
              <p-inputSwitch color="primary" (onChange)="onQuestionToggle(i, a.get('answer').value)" formControlName="answer"></p-inputSwitch>
            </div>
          </div>
          <div class="p-grid" *ngIf="fields.showAdditionalAnswerForQuestions && a.get('answer').value">
              <div class="p-col-5" *ngIf="i===0 || (i > 1 && questionList[i]?.isAdditionalInfoReq)">
                <label class="create-task-label required">How many? </label>
                <p-inputNumber class="d-block" [min]="1" [max]="99" [maxlength]="2" styleClass="create-task-input"
                  [useGrouping]="false" placeholder="Enter" formControlName="additionalInfo">
                </p-inputNumber>
                <span class="invalid-message"
                  *ngIf="a.get('additionalInfo').touched && a.errors && a.errors['additionalInfoIsRequired']">
                  Required
                </span>
              </div>
              <div class="p-col-10" *ngIf="i===1 || questionList[i]?.hasExplanation">
                <label class="create-task-label">Explanation</label>
                <textarea rows="3" formControlName="additionalInfo" class="create-task-textarea d-block p-inputtext"
                  placeholder="Enter" pInputTextarea autoResize="autoResize"></textarea>
                <span class="invalid-message"
                  *ngIf="a.get('additionalInfo').touched && a.errors && a.errors['additionalInfoIsRequired']">
                  Required
                </span>
              </div>
            <!-- <div class="p-col-5" *ngIf="i===3 && questionList[i]?.isAdditionalInfoReq">
              <label class="create-task-label required">How many? 3</label>
              <p-inputNumber class="d-block" [min]="1" [max]="99" [maxlength]="2" styleClass="create-task-input"
                [useGrouping]="false" placeholder="Enter" formControlName="additionalInfo">
              </p-inputNumber>
              <span class="invalid-message"
                *ngIf="a.get('additionalInfo').touched && a.errors && a.errors['additionalInfoIsRequired']">
                Required
              </span>
            </div>
             -->
          </div>
          <div class="mt-3 p-col-12" *ngIf="!questionList[i].isBoolean || questionList[i].isBoolean == 0">
            <input class="im-input mb-4" type="text" placeholder="Enter" formControlName="additionalInfo" />
          </div>
        </div>
      </div>
    </div>

    <div class="p-grid dashed-line p-my-4"></div>

    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-6">
        <label class="create-task-label">Type of Beneficiaries Requested </label>
        <div class="p-formgroup-inline">
          <div class="p-field-checkbox">
            <p-radioButton name="beneficiaryType" value="named" 
              formControlName="beneficiaryType" inputId="named"></p-radioButton>
            <label for="named" class="create-task-label">Named</label>
          </div>
          <div class="p-field-checkbox">
            <p-radioButton name="beneficiaryType" value="unnamed" 
              formControlName="beneficiaryType" inputId="unnamed"></p-radioButton>
            <label for="unnamed" class="create-task-label">Unnamed (for H-2A or H-2B petition only)</label>
          </div>
        </div>
        <span class="invalid-message"
          *ngIf="petitionTaskForm.get('beneficiaryType').touched && petitionTaskForm.get('beneficiaryType').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>

      </div>
    </div>

    

    <!-- Hide section IMGLT-568 -->
    <!-- <div class="p-fluid p-formgrid p-grid" style="display: none;">
      <div class="p-col-12">
        <label class="label-large-bold">Processing Information</label>
      </div>
      <div class="p-col-4">
        <label class="create-task-label required">Select Processing Type</label>
        <div class="p-formgroup-inline">
          <div class="p-field-checkbox">
            <p-radioButton name="processingType" value="regular" (onClick)="onChangeProcessingType()"
              formControlName="processingType" inputId="regular"></p-radioButton>
            <label for="regular" class="create-task-label">Regular</label>
          </div>
          <div class="p-field-checkbox">
            <p-radioButton name="processingType" value="premium" (onClick)="onChangeProcessingType()"
              formControlName="processingType" inputId="premium"></p-radioButton>
            <label for="premium" class="create-task-label">Premium</label>
          </div>
        </div>
        <span class="invalid-message"
          *ngIf="petitionTaskForm.get('processingType').touched && petitionTaskForm.get('processingType').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>    
      </div>
      <div class="p-col-4">
        <label class="create-task-label required">Select {{visaType === 'H1-B' ? 'Lockbox' : 'Service Center'}}</label>    
        <p-dropdown [options]="serviceCenters" formControlName="serviceCenterId" name="serviceCenterId" optionLabel="name"
          optionValue="id" placeholder="Select">
        </p-dropdown>
        <span class="invalid-message"
          *ngIf="petitionTaskForm.get('serviceCenterId').touched && petitionTaskForm.get('serviceCenterId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>    
      </div>    
    </div> -->

    <div class="p-grid dashed-line p-my-4" *ngIf="!subTaskDetails && fields.showDividerBeforeForeignCompany"></div>
    <div class="p-fluid p-formgrid p-grid"
      *ngIf="!subTaskDetails && (fields.showForeignCompany || fields.showRelationshipOfUSCompanyWithForeignCompany || fields.showTreatyCountry)">
      <div class="p-col-12">
        <label class="label-large-bold">Foreign Company Information</label>
      </div>
      <div class="p-col-4" *ngIf="fields.showForeignCompany">
        <label class="create-task-label required">Foreign Company</label>
        <p-dropdown [options]="foreignCompanyList" formControlName="foreignCompanyId" name="foreignCompanyId"
          (onChange)="onForeignCompanyChange()" optionLabel="companyName" optionValue="id" placeholder="Select">
        </p-dropdown>
        <small class="p-error" *ngIf="!foreignCompanyList || (foreignCompanyList && foreignCompanyList.length === 0)">
          <span *ngIf="['L1A', 'L1B'].includes(visaType)">There are no associated companies having non-US
            incorporation country.</span>
          <span *ngIf="['E1', 'E2', 'E2C'].includes(visaType)">There are no associated companies in the treaty
            countries for the selected visa.</span>
        </small>
        <span class="invalid-message"
          *ngIf="petitionTaskForm.get('foreignCompanyId').touched && petitionTaskForm.get('foreignCompanyId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="p-col-4" *ngIf="fields.showRelationshipOfUSCompanyWithForeignCompany">
        <label class="create-task-label required">Relationship of US Company with Company
          abroad</label>
        <p-dropdown [options]="companyRelationList" formControlName="companyRelationCode" name="companyRelationCode"
          optionLabel="name" optionValue="code" placeholder="Select">
        </p-dropdown>
        <span class="invalid-message"
          *ngIf="petitionTaskForm.get('companyRelationCode').touched && petitionTaskForm.get('companyRelationCode').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="p-col-4" *ngIf="fields.showTreatyCountry">
        <label class="create-task-label">Treaty Country</label>
        <input type="text" pInputText formControlName="treatyCountry" [readonly]="true" class="form-control txt-comp" />
      </div>
    </div>
    <div class="p-grid dashed-line p-my-4"></div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-12">
        <label class="label-large-bold">Who will be the signatory for this task / petition</label>
      </div>
      <div class="p-col-4">
        <label class="create-task-label required">Signatory Name</label>

        <p-dropdown [options]="reviewUsersList" formControlName="authorizedSignatoryId" name="authorizedSignatoryId"
          optionLabel="firstName" optionValue="id" placeholder="Select Signatory" (onChange)="userSelected()">

          <ng-template pTemplate="selectedItem">
            <div *ngIf="selectedSignatory">
              <div>{{selectedSignatory?.firstName +' '+selectedSignatory?.lastName}}</div>

            </div>
          </ng-template>
          <ng-template let-employee pTemplate="item">
            <div>
              <div>{{employee?.firstName +' '+employee?.lastName}}</div>
            </div>
          </ng-template>
        </p-dropdown>
        <span class="invalid-message"
          *ngIf="petitionTaskForm.get('authorizedSignatoryId').touched && petitionTaskForm.get('authorizedSignatoryId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="p-col-4">
        <label class="create-task-label">Designation</label>
        <input type="text" readOnly name="selectedDesignation" class="form-control txt-comp"
          formControlName="selectedDesignation" />
      </div>

    </div>
    <div class="p-grid dashed-line p-my-4"></div>
    <div *ngIf="isAttorneySelect">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12">
          <label class="label-large-bold">Lawfirm Information</label>
        </div>
        <div class="p-col-4">
          <label class="create-task-label">Lawfirm</label>
          <p-dropdown [options]="attorneys" formControlName="attorneyId" name="attorneyId" optionLabel="attorneyName"
            optionValue="attorneyId" (onChange)="attorneySelected()" placeholder="Select lawfirm">
          </p-dropdown>
          <!-- <span class="invalid-message" *ngIf="petitionTaskForm.get('attorneyId').touched && petitionTaskForm.get('attorneyId').errors?.required">
        {{ getGlobalErrorMessages("REQUIRED") }}
        </span> -->
        </div>
        <div class="p-col-4">
          <label class="create-task-label">Authorized Signatory</label>
          <p-dropdown [options]="attorneyUsers" formControlName="preparerAttorneyId" name="preparerAttorneyId"
            optionLabel="firstName" optionValue="id" placeholder="Select Preparer" (onChange)="userPreparerSelected()">

            <ng-template pTemplate="selectedItem">
              <div *ngIf="selectedPreparer">
                <div>{{selectedPreparer?.firstName +' '+selectedPreparer?.lastName}}</div>

              </div>
            </ng-template>
            <ng-template let-employee pTemplate="item">
              <div>
                <div>{{employee?.firstName +' '+employee?.lastName}}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <!-- <span class="invalid-message" *ngIf="petitionTaskForm.get('preparerAttorneyId').touched && petitionTaskForm.get('preparerAttorneyId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
          </span> -->
        </div>

      </div>
    </div>
    <div *ngIf="!isAttorneySelect">
      <h5 class="labelText">Lawfirm Details </h5>
      <div class="p-grid">
        <div class="p-col-12 pl-0">
          <label class="mt-2 ml-2 create-task-label label-cls">Firm Name</label>
          <div class="row mt-1 ml-2">
            <strong>{{employeeDetails?.companyName}}</strong>
          </div>
        </div>
        <div class="p-col-4">
          <label class="mt-2 d-block create-task-label">Authorized Signatory</label>
          <!-- <div class="row mt-1 ml-2">
            {{employeeDetails?.firstName ? employeeDetails?.firstName +' '+employeeDetails?.lastName : '--'}}
          </div> -->
          <p-dropdown [options]="attorneyUsers" formControlName="preparerAttorneyId" name="preparerAttorneyId"
            optionLabel="firstName" optionValue="id" placeholder="Select Preparer" (onChange)="userPreparerSelected()" class="w-100" appendTo="body">

            <ng-template pTemplate="selectedItem">
              <div *ngIf="selectedPreparer">
                <div>{{selectedPreparer?.firstName +' '+selectedPreparer?.lastName}}</div>

              </div>
            </ng-template>
            <ng-template let-employee pTemplate="item">
              <div>
                <div>{{employee?.firstName +' '+employee?.lastName}}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="p-col-4">
          <label class="mt-2 d-block create-task-label">Law Firm Users</label>
          <p-multiSelect class="w-100" optionValue="id" [options]="lawFirmUsersList"
            formControlName="lawFirmUsers" appendTo="body" defaultLabel="Select" optionLabel="firstName" (onChange)="usersLawFrimSelected()">
              <ng-template pTemplate="selectedItems">
                <div *ngIf="selectedLawFirmUsers.length">{{selectedLawFirmUsersTextArr.join(', ')}}</div>
                <div *ngIf="!selectedLawFirmUsers.length">Select</div>
              </ng-template>
              <ng-template let-employee pTemplate="item">
                <div>{{employee?.firstName +' '+employee?.lastName}}</div>
              </ng-template>
            </p-multiSelect>
        </div>
      </div>
    </div>
    <div class="p-grid dashed-line p-my-4"></div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-12">
        <label class="label-large-bold">Petitioner Information</label>
      </div>
      <div class="p-col-4">
        <label class="create-task-label required">Petitioner Preparer Name</label>


        <p-dropdown [options]="users" formControlName="immSpecialistId" name="immSpecialistId" optionLabel="firstName"
          optionValue="id" placeholder="Select Petitioner Preparer" (onChange)="onPetitionerPreparerSelected()" appendTo="body">

          <ng-template pTemplate="selectedItem">
            <div *ngIf="selectedPetetionPreprarer">
              <div>{{selectedPetetionPreprarer?.firstName ? selectedPetetionPreprarer?.firstName +'
                '+selectedPetetionPreprarer?.lastName : '--'}}</div>

            </div>
          </ng-template>
          <ng-template let-employee pTemplate="item">
            <div>
              <div>{{employee?.firstName +' '+employee?.lastName}}</div>
            </div>
          </ng-template>
        </p-dropdown>
        <span class="invalid-message"
          *ngIf="petitionTaskForm.get('immSpecialistId').touched && petitionTaskForm.get('immSpecialistId').errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>

  </div>
</div>